import { logoutUserSuccess } from 'redux/auth/authActions';
import { localStorageKey } from 'constants/index';
import { jobcaseSignInUrl } from './postLoginRedirect';

let redirecting = false;

// A rejected refresh token cannot be recovered in place. Clear the EC1 credentials and go
// directly to sign-in; the saved route brings the person back after a successful login.
const endJobcaseSession = (dispatch, location = window.location,
   navigate = (url) => window.location.replace(url)) => {
   if (redirecting) {
      return;
   }
   redirecting = true;
   const loginUrl = jobcaseSignInUrl(location.pathname, location.search);
   dispatch(logoutUserSuccess(''));
   localStorage.removeItem(localStorageKey.arrivalKey);
   navigate(loginUrl);
};

export default endJobcaseSession;
